import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Logo from '../images/logo.png';

const styles = theme => ({
    root: {
        background: '#fff',
        position: 'relative',
        zIndex: '1000',
        boxShadow: 'none !important'
    },
    subNavRoot: {
        background: '#fff',
        position: 'relative',
        boxShadow:
            '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12) !important',
        marginBottom: '1em'
    },
    subNavLinks: {
        '& a': {
            color: '#50b9b3',
            marginLeft: '.4em',
            marginRight: '.4em',
            padding: '0.5em 0',
            display: 'inline-block',
            textDecoration: 'none',
            textTransform: 'uppercase',
            fontFamily:
                'Montserrat,Helvetica,Arial,Lucida,sans-serif !important',
            fontSize: 15
        }
    },
    heading: {
        color: '#fff',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '28px'
        }
    },
    toolbar: {
        justifyContent: 'center'
    },
    subNavToolbar: {
        minHeight: '0',
        justifyContent: 'center',
        paddingLeft: '8px !important',
        paddingRight: '8px !important'
    },
    logo: {
        maxWidth: '200px',
        display: 'block',
        minWidth: 50,
        marginTop: 10
    }
});

const Header = ({ classes, isAuthenticated, handleAuth }) => {
    const onSignOut = async e => {
        e.preventDefault();
        try {
            await Auth.signOut();
            handleAuth(false);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <AppBar className={classes.root} position="static" color="default">
                <Toolbar className={classes.toolbar}>
                    <Typography
                        className={classes.heading}
                        component="h1"
                        variant="h3"
                        align="center"
                    >
                        <Link to="/">
                            <img
                                className={classes.logo}
                                src={Logo}
                                alt="ShuttleID"
                            />
                        </Link>
                    </Typography>
                </Toolbar>
            </AppBar>

            <div className={classes.subNavRoot} color="default">
                <Toolbar className={classes.subNavToolbar}>
                    <Typography
                        className={classes.subNavLinks}
                        component="div"
                        variant="body2"
                        align="center"
                    >
                        <Link to="/">Bus tickets</Link>
                        {isAuthenticated && (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <Link to="/account">Account</Link>
                        )}
                        <Link to="/help">Help</Link>
                        {isAuthenticated && (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a href="#" onClick={onSignOut}>
                                Logout
                            </a>
                        )}
                    </Typography>
                </Toolbar>
            </div>
        </div>
    );
};

Header.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(Header);
